import * as React from 'react';
import { WebDate } from '../../../../WebDate';
import { HeaderLogoAndTel } from '../../../../HeaderLogoAndTel';
import * as screen1 from './style.module.scss';
export const Screen1 = ({ id, widgetFree }) => {
  return (
    <section className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel />
        <div className={screen1.container}>
          <div className={screen1.info}>
            <div className={screen1.inner}>
              <p className={screen1.type}>Бесплатный 5-дневный марафон</p>
              <time>
                🕗 <WebDate id={id} dateText={' (Москва)'} />
              </time>
            </div>
            <h1>Марафон развития мозга и навыков обучения</h1>
            <p className={screen1.sub}>
              Попробуйте нейроупражнения, мнемотехники,
              <br /> майнд-карты, скорочтение и многое другое <br />
              на своем опыте
            </p>
            <div className={screen1.reg}>
              <div className={screen1.form}>
                <h3>Заполните поля и получите доступ к марафону:</h3>
                {widgetFree}
              </div>
            </div>
            <p className={screen1.giftBlock}>
              <span>Подарок участникам:</span>
              <br /> 20 упражнений пальчиковой гимнастики для развития мозга
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
